import { createSelector } from 'reselect';

export const serverSpecItems = (store) =>
	store.Filters.loadFilters?.data?.entity?.spec?.value || [];

export const getEvents = createSelector(serverSpecItems, (items) => {
	return items.map((item) => ({ label: item.name, value: `${item.key}` }));
});
